import React from 'react';
import styled from 'styled-components';
import {
    Heading,
    Text,
    Button,
    Flex,
    spacing,
    ArrowForwardOutlined,
    useBreakpoint,
} from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { CONFIG } from 'utils/config';
import { getReturnUrl } from 'helpers';
import { useExecutionEnvironmentContext } from 'contexts/ExecutionEnvironmentContext/ExecutionEnvironmentContext';

const NeedMoreSamplesFlex = styled(Flex)`
    padding: ${spacing('mg')};

    align-items: center;
    align-content: center;
    justify-content: center;
    text-align: center;

    ${({ theme }): string => theme.breakpoint('lg')`
        padding: ${spacing('mg')} ${spacing('lg')};
    `}
`;

export const _NeedMoreSamples = ({
    linkToSamplesPricing,
    target,
    isMobile,
}: {
    linkToSamplesPricing: string;
    target: '_self' | '_blank';
    isMobile: boolean;
}) => {
    return (
        <NeedMoreSamplesFlex
            flexDirection="column"
            justifyContent="space-between"
        >
            <Heading as="h2" size={isMobile ? 'xxxl' : 'mg'}>
                <Trans>Need even more samples?</Trans>
            </Heading>
            <Text size={isMobile ? 'base' : 'lg'} contrast="low">
                <Trans>
                    Need even more samples? Find the plan that fits your flow or
                    grab a quick credit top up to keep the music going!
                </Trans>
            </Text>
            <Button
                as="a"
                href={linkToSamplesPricing}
                isRounded
                iconRight={ArrowForwardOutlined}
                mt="jb"
                target={target}
            >
                <Trans>See plans & pricing</Trans>
            </Button>
        </NeedMoreSamplesFlex>
    );
};

export const useNeedMoreSamples = ({
    isDAWPlugin,
}: {
    isDAWPlugin: boolean;
}) => {
    const linkToSamplesPricing = `${
        CONFIG.VITE_PRICING_URL
    }/samples?returnUrl=${getReturnUrl()}`;
    const target: '_blank' | '_self' = isDAWPlugin ? '_blank' : '_self';

    return { linkToSamplesPricing, target };
};

const NeedMoreSamples = () => {
    const isMobile = useBreakpoint('md');
    const { isDAWPlugin } = useExecutionEnvironmentContext();
    const { linkToSamplesPricing, target } = useNeedMoreSamples({
        isDAWPlugin,
    });

    return (
        <_NeedMoreSamples
            linkToSamplesPricing={linkToSamplesPricing}
            target={target}
            isMobile={isMobile}
        />
    );
};

export default NeedMoreSamples;
